import Stripe from 'stripe';

export enum SubscriptionStatus {
  NOT_FOUND = 'not_found',
  INVALID = 'invalid',
  NOT_SUBSCRIBED = 'not_subscribed',
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
  INACTIVE = 'inactive',
  TRIALING = 'trialing',
  PAUSED = 'paused',
  PAST_DUE = 'past_due',
  EXPIRED = 'expired',
  FREE = 'free', // when the user is on the free plan
  UNINITIALIZED = 'uninitialized', // when the subscription status is not yet known
  UNKNOWN = 'unknown', // when the subscription status is not (yet) known
}

export interface SubscriptionState {
  status: SubscriptionStatus;
  loading: boolean;
  error: Record<string, unknown> | null;
  subscriptionInfo?: SubscriptionInfo;
}

export interface PlanObject {
  product: {
    id: string;
    name: string;
    metadata: Record<string, string>;
  };
  plan: {
    id: string;
    interval: string;
  };
}
export interface SubscriptionData {
  stripeCustomerId?: string;
  status: SubscriptionStatus;
  startDate?: string;
  periodStartDate?: string;
  periodEndDate?: string;
  freePlan?: boolean;
  lastRenewalDate?: string;
  nextRenewalDate?: string;
  conversionDate?: string;
  trialEndBehavior?: string;
  expiresIn?: number;
  convertsIn?: number;
  renewsIn?: number;
  convertingToPaidPlan?: boolean;
  conversionProduct?: string;
  message?: string;
  stripeSubscriptionId?: string;
  rawData?: Stripe.Subscription;
}

export interface SubscriptionInfo {
  cirraUserId?: string; // External (Auth0) ID for the user (== email)
  cirraOrganizationId?: string; // External (Auth0) ID for the organization
  organizationId?: string; // Internal (Mongo) ID for the organization
  userId: string; // Internal (Mongo) ID for the user
  stripeCustomerId?: string;
  // license?: string;
  role?: string;
  subscription: SubscriptionData;
}
